import styled from "styled-components";

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  grid-column: span 2;
`;

export const LinkHeading = styled.h3`
  font-weight: 600;
  font-size: 1.375rem;
  line-height: 1.65;
  color: black;
`;

export const LinksAnchor = styled.div``;

export const Link = styled.a`
  display: block;
  padding: 8px 0;
  color: #8a8fb9;
  font-size: 0.889rem;
  line-height: 1.2rem;
  transition: all 3s linear;

  &:hover {
    text-decoration: underline;
  }
`;
